const Pulse = ({ className }: { className: string }) => (
  <span className={`block animate-pulse rounded-lg bg-gray-200/80 ${className}`} aria-hidden="true" />
);

export function MetricsPageInitialSkeleton() {
  return (
    <div className="h-[100dvh] overflow-hidden bg-[#F7F8FA]" role="status" aria-label="Cargando Métricas">
      <div className="flex h-16 items-center justify-between border-b border-gray-200 bg-white px-6">
        <div className="flex items-center gap-4">
          <Pulse className="h-8 w-16" />
          <Pulse className="size-10 rounded-full" />
          <Pulse className="h-5 w-20" />
          <Pulse className="h-10 w-64 rounded-full" />
        </div>
        <div className="flex items-center gap-2">
          <Pulse className="size-10 rounded-full" />
          <Pulse className="h-10 w-32 rounded-full" />
          <Pulse className="size-10 rounded-full" />
        </div>
      </div>
      <div className="grid h-[calc(100dvh-64px)] grid-cols-[340px_minmax(0,1fr)]">
        <aside className="overflow-hidden border-r border-gray-200 bg-white p-3">
          <Pulse className="h-10 w-full rounded-full" />
          <Pulse className="mt-3 h-10 w-full rounded-full" />
          <div className="mt-5 space-y-2">
            {Array.from({ length: 8 }, (_, index) => (
              <div key={index} className="flex items-center gap-3 rounded-lg px-3 py-2.5">
                <Pulse className="size-9 shrink-0" />
                <div className="min-w-0 flex-1 space-y-2">
                  <Pulse className="h-3 w-3/4" />
                  <Pulse className="h-2.5 w-2/5" />
                </div>
                <Pulse className="h-3 w-24" />
              </div>
            ))}
          </div>
        </aside>
        <main className="overflow-hidden p-6">
          <div className="grid grid-cols-2 gap-4 xl:grid-cols-4">
            {Array.from({ length: 4 }, (_, index) => (
              <div key={index} className="min-h-[112px] rounded-2xl border border-gray-200 bg-white p-5">
                <Pulse className="h-3 w-20" />
                <Pulse className="mt-4 h-7 w-28" />
                <Pulse className="mt-3 h-3 w-36 max-w-full" />
              </div>
            ))}
          </div>
          <div className="mt-5 min-h-[280px] rounded-2xl border border-gray-200 bg-white p-5">
            <Pulse className="h-5 w-40" />
            <div className="mt-8 space-y-5">
              {Array.from({ length: 5 }, (_, index) => (
                <div key={index} className="flex items-center gap-4">
                  <Pulse className="size-8 rounded-full" />
                  <Pulse className="h-3 flex-1" />
                  <Pulse className="h-4 w-20" />
                </div>
              ))}
            </div>
          </div>
        </main>
      </div>
      <span className="sr-only">Cargando contenido…</span>
    </div>
  );
}
